package io.jsonize.web.screens.editor

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import io.jsonize.web.screens.editor.EditorFileProgress

@Composable
fun FileProgressIndicator(progress: EditorFileProgress) {
    val ratio =
        if (progress.totalBytes > 0)
            progress.loadedBytes.toFloat() / progress.totalBytes.toFloat()
        else 0f

    Surface(
        tonalElevation = 4.dp,
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 6.dp)
    ) {
        Column(Modifier.padding(8.dp)) {
            Text("Reading ${progress.fileName}")
            LinearProgressIndicator(
                progress = { ratio },
                modifier = Modifier.fillMaxWidth().padding(top = 6.dp)
            )
            Text(
                "${progress.loadedBytes / 1024} KB / ${progress.totalBytes / 1024} KB",
                style = MaterialTheme.typography.bodySmall
            )
        }
    }
}
